import React from 'react'

const Paragraph = ({variant="", content=""}) => {
  return (
    <>
        {variant === "lead" ? (
            <span className="leadText">{content}</span>
        ) : (
            <p>{content}</p>
        )}
    </>
  )
}

export default Paragraph